module.exports = __webpack_public_path__ + "static/media/Songs 2.5153303d.svg";